export const SERVICE_WORKER_REGISTRATION_OPTIONS = {
  scope: "/",
  updateViaCache: "none",
} as const satisfies RegistrationOptions;

export function versionedServiceWorkerUrl(revision: string): string {
  const normalizedRevision = revision.trim();
  if (!/^[a-f0-9]{16}$/i.test(normalizedRevision)) {
    throw new Error("SERVICE_WORKER_REVISION_INVALID");
  }
  return `/sw.js?v=${encodeURIComponent(normalizedRevision)}`;
}
